var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerrainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 45,
    fill: "url(#pattern0_2592_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2592_12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2592_12",
    transform: "scale(0.0192308 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2592_12",
    width: 52,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAtCAYAAADhoUi4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7ElEQVRogdXaeaxdUxTH8c97r1rhFdVWEEPQdFBHihSVENM/FaLiD6SaF9RQUYJIVRRJhaBE0qCIGCr1hyb8YUqotKSGSGM47RW0qlJDGnSihnr4Y53be3rde9+dnj7f5Obdd87ee+119z7rt/bep6NQKGiQwZiAMdgfnY02UAff4wt8iF8bqTioznKdmIJpOANr8Cm+QW8jBuu0NR7XYByW42ksxh99Va7HoXNxDzbiUVyaff8v6MbZmI67MQcL8Xe1Ch01ptzeeAxH41q83s6eNsEkzBc/5jQxLf9Ftfl/KN7DDzjGrncG3sUJ2d/3cWSlQpWm3EF4Aw/hwX7qXLP04jYRMJbgZKzOFyh3aDBewBMGnjN5FmJ3vIKJ2Fy8UT7l5mK9CAIDncfFKM3PX8yP0DhcgqPUiCLlpGla63Y3fsOf1QokSVKvqUrchFU4BW+x8wjdivuxoRULOcaISPSxmB79wc+4Pfug5NB+OAsPt8lQBxZgTxGNbmlTu5V4FmMzOzscOh8vYWubjPTg1Nz/s8SU7g/+xCJcSMmhM/FamwyMwLzs+1NYKaLnAjFy/cGrIiXb4dCxQqzawTwMF8/iDbhSBJlTRNDpDz4QCXNHp4h0B2JtGxo+TUw3uF6kKe+IFAruE88V7IHL0zQd1Qa7W7EFB3RiKH7RetY8REwrIlValLt3s9C3QUpScZdw9OU0TYe0aBt+wj5Fh9oRDGZjtNCdGWX3NomgcIhQ9eMwM7s3OqvbKr3oatfibIxSp+aK9VI5PwtnusTIdGbXYHaapmPa0ZF2OFTUnMEoiOekFjNFEOoVob2Q1V2QpmnLUbAdDuU15wpsr1H2YDGC8ABWZHVkbfRUqNMQLTmUpmlecx4Xy+VazBf53TrcAUmSLM/qwryszaZpdYTymjOrj7JTxHIersa23L1ZWRvDlX6gpmjaoTRNK2lONYYqpfnPi3XMDpIk2Zi1AT1Z203RlEOZblTTnErMFSvhLbiuUoEkSRYpLfUXNKtNzY5QLc0p5wglzZmN72qUnZG12bQ2NexQphd9aU6e7WJkliiNakWSJFmjFAWb0qaGHMp0ohHNga8xUmT0f9VR/j4taFOjI7ST5iRJUktz8lRdgpeTtdm0NnUUCoVD8LbYi6tKmqZ74UsRWntFslmLYSKjJnK5XxrpmAgiXfgRhydJsqWP8p9g6iCRmA6tw8BI4YzMUM0foIwR2acZhme2+3KoC71Fh/YsXqhWOkmSNWmaTsBhdXZkX4zK2lyJ3+usV87aLFj0xTBsKu5tfyUe2tW1agxghoodpu5iUFiB43ddf1pmIj7C30WHlmDyLutO60zGm5TC9mKco77gMNAYhIvwHCWHNuBlkQX/35iKz4QY73TgdSSWir3tdm0H9zfdIoL2YBk7ZwoFPKl/NwTbzb1ik35Z8UJ56jNH7Mz0tVgbCFyGk3BV/mL5gdcfYmW5VKTxD/Z/v5riYtwpwnV+5VvxSHK92Cd+TSj9jZpX+XbTJY5OekQf/5VPVsu21+FEkUN9mFXe1UwSB9mTxOFxxeP7Wu8pbMYFYgo+Ik7EH8OLInv+L+gW51bTxRnQHDyjyfcU8nTiPPF+wOlilboK34rkts83POpkN+HEgWI3drwG3ySp16E8xXd9xuIAkakPbrSRKmwX28Mb8LmY7ttq1ijjH2CHOWLeBHwJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrainIcon);
export default __webpack_public_path__ + "static/media/terrain-icon.419430259abb544642b71f34558ad501.svg";
export { ForwardRef as ReactComponent };